import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IGetAllWorkersRequestParams from 'services/httpClient/requests/worker/IGetAllInterventionRequestParams';
import IGetAllWorkerListResponse from 'services/httpClient/responses/worker/IGetAllWorkerListResponse';

import { workerActions } from '../index';
import { IWorkerGetAllRequestAction } from '../reducers/getAll/request';

function* getAll(action: PayloadAction<IWorkerGetAllRequestAction>) {
  try {
    const params: IGetAllWorkersRequestParams = {
      filters: action.payload.data.filters,
    };
    const { data }: AxiosResponse<IGetAllWorkerListResponse[]> = yield call(
      httpClient.get,
      `backoffice/v1/intervention_partnerships/${action.payload.data.id}/workers`,
      { params },
    );
    if (!data.length) {
      yield put(
        workerActions.getAllSuccessWithoutData({
          message: 'noWorkersFound',
        }),
      );
      return;
    }
    yield put(
      workerActions.getAllSuccessWithData({
        list: data,
      }),
    );
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(workerActions.getAllFailure());
  }
}

export default getAll;
